import Link from "./Link";

export default Link;
export type { CustomLinkProps } from "./Link";
